module.exports = __webpack_public_path__ + "resources/img/img_ahnlab_cpp2.24f69e384c4afce857a484d3939aaa25.png";